import Vue from 'vue'
import objectUtil from '../../../static/js/objectUtil'
import template from '../../../static/js/template'
import templateUtil from '../../../static/js/templateUtil'
import dynamicItemUtil from '../../dynamicFrom/libs/dynamicItemUtil'
import compileVariableUtil from '../../../static/js/compileVariableUtil'
const getValue = objectUtil.getValueByPath
const InstanceDaed = function (dom) {
  if (dom) {
    dom.$destroy()
    dom.$el.parentNode.removeChild(dom.$el)
    for (var key in dom) {
      delete dom[key]
    }
    dom = null
    console.info('menuUtils.typeMethod.component  $destroy')
  }
}

const renderInstance = {
  // 已经渲染的实例
  renderedInstance: null,
  // 销毁实例
  destroyInstance() {
    if (this.renderedInstance) {
      InstanceDaed(this.renderedInstance)
      this.renderedInstance = window.onkeyup = null
    }
  },
  // 渲染单元格组件
  singleCellEdit(row, item, cell, event, index, that) {
    const dataIndex = index,
      data = row // dataIndex 行号，row 行数据 // that.data.findIndex(im => im._ID === row._ID);
    let componentName = item.component && item.component.code ? item.component.code : 'readText'
    componentName = dynamicItemUtil.convertComponentName(componentName)
    componentName === 'i-input' && (componentName = 'Input')
    let componentClass = that.$allComponents[componentName]
    if (!componentClass) {
      var msg = '组件不存在：' + componentName
      console.error(msg)
      alert(msg)
      return
    }
    // 暂时处理发货单拆分问题（拆行临时方案）
    if (!that.disabled && that.useMaster && data && data.hasOwnProperty('master') && !data.master) {
      if (item.code === 'goodsDetail.name' || item.code === 'waresDetail.name') {
        initValue = null
        componentClass = 'readText'
      }
    }
    let propsCompileData = compileVariableUtil.getCompileVariable(data, that)
    //特殊处理传递
    let parentDataKey = getValue(that.store, 'states.parentDataKey', 'parentFormData')
    propsCompileData.dataIndex = dataIndex
    propsCompileData.parentData = getValue(that.extendData, 'formData') || window[parentDataKey]
    let propsCompile,
      field = item.property
    try {
      propsCompile = template.render(item.parameter, propsCompileData)
    } catch (e) {
      propsCompile = item.parameter
    }

    // 不编译_props.changeBorthers
    if (propsCompile.changeBorthers) propsCompile.changeBorthers = item.parameter.changeBorthers

    if (!propsCompile) propsCompile = {}
    //当为input组件时支持设置maxlength
    if (item.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentName)) {
      propsCompile.maxlength = propsCompile.maxlength ?? item.length
    }
    if (item.disabled) {
      propsCompile.disabled = item.disabled
    }
    if (propsCompile.disabled) return
    propsCompile.feild = field
    let optionModel
    if (field) {
      propsCompileData.otherRow = false // otherRow 表示是否是从行
      propsCompileData.row = data // row 行数据
      var initValue = getValue(data, field) // 处理主行 item.template 数据渲染
      optionModel = {
        value: initValue,
        callback: ($$v) => {
          objectUtil.setValueByPathForVue(data, field, $$v, that)
          that.CellDynamicChange(data, field, $$v, dataIndex)
          const cBorthers = propsCompile.changeBorthers

          if (cBorthers) {
            let temp = {}
            Object.keys(cBorthers).forEach((im) => {
              let otherFields = cBorthers[im]
              if (!otherFields) {
                temp[im] = otherFields
              } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                temp[im] = templateUtil.compileData(otherFields, propsCompileData)
              } else {
                temp[im] = getValue($$v, otherFields)
              }
            })
            console.log('******sideSelect***this.changeBorthersObj***********', this.temp)
            Object.keys(temp).forEach((im) => {
              objectUtil.setValueByPathForVue(data, im, temp[im], that)

              // 修复bug#32549
              that.CellDynamicChange(data, im, temp[im], dataIndex)
            })
          }

          if (propsCompile.rowDataReplaceInfo) {
            that.rowDataReplace(data, propsCompile.rowDataReplaceInfo, dataIndex)
          }
        },
      }
    }
    //监听discountEdit组件变化抛出事件调用计算折扣
    let eventOn = {}
    if (componentClass == 'discountEdit') {
      eventOn = {
        'on-change': (fildKey, fild) => {
          //
          // that.$emit("on-change-discountEdit", data, fildKey, fild, dataIndex);
          that.onChangeDiscountEdit(data, fildKey, fild, dataIndex)
        },
      }
    }

    //将store向下传递
    propsCompile.store = that.store
    let cellSpan = cell.querySelector('.cell-span-edit')
    let Instance = new Vue({
      store: that.$store,
      render(h) {
        let vNodeFn = h(componentClass, {
          props: propsCompile,
          model: optionModel,
          on: eventOn,
          ref: 'serfRef',
          style: template.render(item.style, propsCompileData), // 让表格单元格组件支持样式表达式配置
        })
        let isSubValue = 'subValue' in propsCompile
        if (isSubValue) {
          let subValue = template.render(item.parameter.subValue, { data: row })
          subValue = this.$options.filters.formatFilter(
            subValue,
            item.parameter.type,
            item.parameter.format
          )
          vNodeFn = h('div', { class: 'cell-two-value' }, [vNodeFn])
          vNodeFn = h('div', { class: 'cell-two-node' }, [vNodeFn, '/', subValue])
        }

        /**
         * 计算双行显示时，操作栏的偏移量
         * 使用场景：合同档案列表-编辑
         * @param {*} index 行号
         * @param {*} row 行数据
         * @returns 偏移量
         */
        const translateYStyle = (index, row) => {
          if (!that.doubleRow) {
            return '-50%'
          }

          if (row.hasOwnProperty('master')) {
            return that.doubleRow === 'all' ? (row.master ? '-175%' : '50%') : '-50%'
          } else {
            return '-50%'
          }
        }

        let componentC = h(
          'div',
          {
            on: {
              click: (e) => e.stopPropagation(),
              keyup: (e) => {
                e.stopPropagation()
                if (e.keyCode === 13) {
                  // 按下 Enter键操作
                  renderInstance.destroyInstance()
                }
              },
            },
            style: {
              position: 'absolute',
              width: '100%',
              padding: '0 5px',
              left: 0,
              top: '50%',
              transform: `translate(0, ${translateYStyle(index, row)})`,
              zIndex: 31,
            },
            class: { 'cell-two': isSubValue },
          },
          [vNodeFn]
        )

        return componentC
      },
      destroyed() {
        cellSpan.style.display = 'block'
      },
      mounted() {
        if (
          item._buttonClick &&
          this.$refs &&
          this.$refs.serfRef &&
          this.$refs.serfRef.referencePriceFn
        ) {
          this.$refs.serfRef.referencePriceFn()
          item._buttonClick = false
        }
      },
    })
    Instance.$parent = that
    let dyncComponent = Instance.$mount().$el

    cellSpan.style.display = 'none'
    cell.appendChild(dyncComponent)
    setTimeout(() => {
      const qInput = dyncComponent.querySelector('input')
      if (qInput) {
        qInput.focus()
        qInput.click()
      }
    }, 150)
    // 创建完成之后 把旧实例销毁了，并把新实例的引用存起来以备下一次销毁,父级组件销毁的时候需要调用销毁;
    this.destroyInstance()
    this.renderedInstance = Instance
    // 绑定键盘事件监听，按tab切换到下一个可编辑的单元格，销毁的时候需要销毁
    window.onkeyup = (e) => {
      if (e.keyCode === 9) {
        let otherColumn = 0
        if (that.selection) {
          otherColumn++
        }
        if (that.indexLabel) {
          otherColumn++
        }
        if (that.iconSelection) {
          otherColumn++
        }
        const items = that.itemsForFilterVisible
        const curentIndex = items.findIndex((im) => im.property === item.property)
        let nextIndex = items.findIndex((im, index) => {
          const cCode = dynamicItemUtil.convertComponentName(im.component.code)
          return index > curentIndex && dynamicItemUtil.isCellRender(cCode)
        })
        let nextCell = nextIndex > 0 ? cell.parentNode.children[otherColumn + nextIndex] : null
        if (nextIndex > 0 && nextCell) {
          nextCell.click()
        } else {
          const nextTr = cell.parentNode.nextElementSibling
          if (nextTr) {
            const isFixedLeft = items[curentIndex].fixed === 'left'
            nextIndex = items.findIndex((im, index) => {
              const cCode = dynamicItemUtil.convertComponentName(im.component.code)
              if (isFixedLeft) {
                return index <= curentIndex && dynamicItemUtil.isCellRender(cCode)
              } else {
                return (
                  index <= curentIndex && im.fixed !== 'left' && dynamicItemUtil.isCellRender(cCode)
                )
              }
            })
            nextCell = nextTr.children[otherColumn + nextIndex]
            nextCell && nextCell.click()
          } else {
            this.destroyInstance()
          }
        }
      }
    }
    // 点击非表格的其他地方 销毁组件
    const main = document.querySelector('body')
    if (main) {
      main.onclick = (e) => {
        const pathElem = e.composedPath()
        for (const eleItem of pathElem) {
          // 在选择日期时不要销毁组件和触发元素在pangutable组件内的不要销毁组件
          if (
            eleItem.className &&
            (~eleItem.className.indexOf('ivu-picker') || ~eleItem.className.indexOf('pangu-table'))
          ) {
            return
          }
        }
        this.destroyInstance()
        main.onclick = null
      }
    }
  },
}

export default renderInstance
